import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { authReducer } from './auth';
import { toastReducer } from './toast';
import { setFeatureFlagContext } from './middleware/setFeatureFlagContext';
import { initializeStore } from './middleware/initializeStore';
import { createCohortReducer } from './create-cohort';
import { dynamoStreamMiddleware } from './middleware/dynamo-stream-middleware';

const rootReducer = combineReducers({
  auth: authReducer,
  toast: toastReducer,
  createCohort: createCohortReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      initializeStore,
      setFeatureFlagContext,
      dynamoStreamMiddleware,
    );
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
